import { isNonEmptyString } from './checks'

const HTML_P_TAG_REGEX = new RegExp('</?p>', 'g')
const BREAK_IN_SENTENCE_REGEX = new RegExp(/[^a-zA-Z|.]/)
const LETTER_VARIATION_LIMIT = 10
export const shortenTextSectionForLineClamp = (
  text: string,
  charLimit: number
): string => {
  if (!isNonEmptyString(text)) {
    return ''
  }
  const formattedString = text.replace(HTML_P_TAG_REGEX, '').trim()

  if (formattedString.length <= charLimit) {
    return '"'.concat(formattedString).concat('"')
  }
  const substringIndex = getSubstringIndexForSplit(formattedString, charLimit)
  return '"'
    .concat(formattedString.substring(0, substringIndex))
    .trim()
    .concat('..."')
}

export const getSubstringIndexForSplit = (
  text: string,
  charLimit: number
): number => {
  const subStringStart = charLimit - LETTER_VARIATION_LIMIT
  const subStringEnd = charLimit + LETTER_VARIATION_LIMIT

  const substring = text.substring(subStringStart, subStringEnd)
  const nonLetterIndex = substring.search(BREAK_IN_SENTENCE_REGEX)

  if (nonLetterIndex !== -1) {
    return subStringStart + nonLetterIndex
  }

  return charLimit
}
